import type { FilterableColumnIds } from './TableFilters.types';

import { FilterChips } from '../FilterChips/FilterChips';
import { useTableContext } from './TableRoot.context';

export const TableFilterTags = () => {
  const { state } = useTableContext();

  if (state.columnFilters.length === 0) return null;

  return (
    <FilterChips.Root>
      {state.columnFilters.flatMap(({ id, value }) =>
        (Array.isArray(value) ? value : [value]).map((filterValue: unknown) => (
          <TableFilterTag columnId={id as FilterableColumnIds} filterValue={filterValue} key={`${id}-${filterValue}`} />
        )),
      )}
    </FilterChips.Root>
  );
};

type Props = {
  columnId: FilterableColumnIds;
  filterValue: unknown;
};

const TableFilterTag = ({ columnId, filterValue }: Props) => {
  const { getColumn } = useTableContext();
  const options = getColumn(columnId)?.columnDef.meta?.filterOptions;

  const label = options?.find((option) => option.value === filterValue)?.label ?? `${columnId}: ${filterValue}`;

  return (
    <FilterChips.Chip
      onRemove={() =>
        getColumn(columnId)?.setFilterValue((value: unknown) => {
          if (!Array.isArray(value)) return null;
          const next = value.filter((v) => v !== filterValue);
          return next.length > 0 ? next : null;
        })
      }
    >
      {label}
    </FilterChips.Chip>
  );
};
